// extracted by mini-css-extract-plugin
export var container = "_d9-0";
export var popoverContent = "_d9-1";
export var tosLink = "_d9-2";